import SidebarLinks from '@theme/components/SidebarLinks.vue';
import NavLinks from '@theme/components/NavLinks.vue';
export default {
  name: 'Sidebar',
  components: {
    SidebarLinks,
    NavLinks
  },
  props: ['items'],
  computed: {
    blogger() {
      return this.$themeConfig.blogger;
    }
  }
};